// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3_sjq","inputWrap":"styles_inputWrap__38lsX","input":"styles_input__3zijD"};